import React, { useContext } from 'react'
import { Modal, Frame } from '@react95/core'
import { Box, Heading, Text } from '@pancakeswap/uikit'
import { Folder, Lock } from '@react95/icons'
import { useTranslation } from 'contexts/Localization'
import { AutoRow } from 'components/Layout/Row'
import { MerchRegionContext } from 'Providers'

const MerchModal = ({ close, modalStyle, frameStyle, iconStyle }) => {
  const { t } = useTranslation()
  const { setRegion } = useContext(MerchRegionContext)
  return (
    <Modal
      defaultPosition={{ x: 8, y: 8 }}
      icon={<Lock variant="16x16_4" />}
      title="Merchandise"
      closeModal={close}
      width="90vw"
      height="90vh"
      style={modalStyle}
      buttons={[{ value: 'Ok', onClick: close }]}
    >
      <Frame style={frameStyle}>
        <Heading scale="xl" mb="16px" mt="16px">
          {t(`Merchandise`)}
        </Heading>

        <Text>If you are having trouble changing regions, reload the page and try again</Text>

        <AutoRow justify="center" align="center">
          <Box
            style={{
              width: '154px',
              textAlign: 'center',
              marginLeft: '16px',
              marginTop: '16px',
              marginBottom: '16px',
              cursor: 'pointer',
            }}
            onClick={() => {
              setRegion('usa')
              window.localStorage.setItem('region', 'usa')
            }}
          >
            <Folder style={iconStyle} />
            <Text color="black" fontSize="20px" textAlign="center">
              {t('USA')}
            </Text>
          </Box>
          <Box
            style={{
              width: '154px',
              textAlign: 'center',
              marginLeft: '16px',
              marginTop: '16px',
              marginBottom: '16px',
              cursor: 'pointer',
            }}
            onClick={() => {
              setRegion('eur')
              window.localStorage.setItem('region', 'eur')
            }}
          >
            <Folder style={iconStyle} />
            <Text color="black" fontSize="20px" textAlign="center">
              {t('Europe / International')}
            </Text>
          </Box>
        </AutoRow>
      </Frame>
    </Modal>
  )
}

export default MerchModal
